/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsIcon16Solid = forwardRef('DocsIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.5 0H8v3.5A1.5 1.5 0 0 0 9.5 5H13v5.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 2 10.5v-8A2.5 2.5 0 0 1 4.5 0Z" }),
        React.createElement("path", { d: "M9 .083 12.916 4H9.5a.5.5 0 0 1-.5-.5V.083Z" }),
        React.createElement("path", { d: "M15.563 5.5a.75.75 0 0 0-1.5 0v5.206a3.25 3.25 0 0 1-3.25 3.25H6.5a.75.75 0 0 0 0 1.5h4.313a4.75 4.75 0 0 0 4.75-4.75V5.5Z" })));
});
